import {
  axisBottom,
  axisLeft,
  curveMonotoneX,
  event,
  format,
  line,
  scaleBand,
  scaleLinear,
  select,
  timeFormat
} from "d3";
import {
  grayLightBackground,
  lightbackground2
} from "../_helpers/_parametric_tools";
import { hLineCreate } from "./D3ChartHoverHelpers";
import { createTooltips } from "./TechnicalAnalysis";
export const SeasonalChart = function(
  parentElement,
  childElement,
  data,
  d3 = null,
  minMaxYAxis,
  formatPercent,
  seasonalityControls,
  seasonalWeek,
  seasonalAve,
  colorSelection,
  hoverYear,
  hoverVal
) {
  this.parentElement = parentElement;
  this.childElement = childElement;
  this.data = data;
  this.d3 = d3;
  this._minimal = minMaxYAxis[0];
  this._maximal = minMaxYAxis[1];
  this.formatPercent = formatPercent;
  this.seasonalityControls = seasonalityControls;
  this.seasonalWeek = seasonalWeek;
  this.seasonalAve = seasonalAve;
  this.colorSelection = colorSelection;
  this.hoverYear = hoverYear;
  this.hoverVal = hoverVal;
};
SeasonalChart.prototype.initVis = function() {
  var vis = this;
  if (this.data === null || this.data === undefined) {
    select("#" + this.parentElement)
      .select("svg > *")
      .remove();
    select("#" + this.parentElement)
      .selectAll(".tooltip")
      .remove();
    return;
  } else if (this.data.length === 0) {
    select("#" + this.parentElement)
      .select("svg > *")
      .remove();

    select("#" + this.parentElement)
      .selectAll(".tooltip")
      .remove();
    return;
  }
  vis.chartDiv = document.getElementById(this.parentElement);
  vis.width = vis.chartDiv.clientWidth;
  vis.height = vis.chartDiv.clientHeight;
  vis.margin = {
    top: 10,
    right: 35,
    bottom: 75,
    left: 55
  };
  vis.width = vis.width - vis.margin.left - vis.margin.right;
  vis.height = vis.height - vis.margin.top - vis.margin.bottom;
  let currWeek =
    vis.data.series.dates[vis.data.series.dates.length - 2].length - 1;
  // create SVG and size it
  select("#" + this.parentElement)
    .select("svg > *")
    .remove();
  select("#" + this.parentElement)
    .selectAll(".tooltip")
    .remove();
  const svg = select("#" + this.childElement)
    .attr("width", vis.width + vis.margin.left + vis.margin.right)
    .attr("height", vis.height + vis.margin.top + vis.margin.bottom)
    .style("fill", "rgba(0, 0, 0, 0)")
    .append("g")
    .attr(
      "transform",
      "translate(" + vis.margin.left + "," + vis.margin.top + ")"
    );
  // set the scales and domains
  vis.x = scaleBand()
    .range([0, vis.width])
    .domain(
      vis.data.dates.map(function(d) {
        return d;
      })
    );
  vis.x2 = scaleBand()
    .range([0, vis.width])
    .domain(
      vis.data.dts.map(function(d) {
        return timeFormat("%d/%b")(d);
      })
    );
  vis.y = scaleLinear()
    .range([vis.height, 0])
    .domain([vis._minimal, vis._maximal])
    .nice();
  var barwidth = vis.x.bandwidth(); // from scale
  // include group background style
  var bkgrnd = svg
    .selectAll(".bkgrnd")
    .data([vis.data.dates])
    .enter()
    .append("g")
    .attr("class", "bkgrnd");
  bkgrnd
    .selectAll("rect") // background color for each week
    .data(function(d) {
      return d;
    })
    .enter()
    .append("rect")
    .attr("x", function(d) {
      return vis.x(d);
    })
    .attr("y", 0) // que solo llegue hasta el x-axis
    .attr("height", vis.height)
    .attr("width", barwidth)
    .attr("fill", "none")
    .classed("currWeek", function(d, i) {
      return i === currWeek;
    });
  // .classed("rise", function () { return true; }); // (i % 2 === 0); })
  //.classed("fall", function (d, i) { return (Math.abs(i % 2) === 1); });
  // add a horizontal line at 0 of yaxis
  svg
    .append("line")
    .attr("class", "xAxisLine")
    .attr("x1", vis.x(0))
    .attr("y1", vis.y(0))
    .attr("x2", vis.width)
    .attr("y2", vis.y(0));
  // add the y Axis
  svg
    .append("g")
    .attr("class", "axis axis--y")
    .call(
      axisLeft(vis.y)
        .tickFormat(vis.formatPercent)
        .tickSize(-vis.width)
        .tickSizeOuter(0)
        .tickPadding(10)
        .ticks(8)
    );
  // y axis label
  svg
    .append("g")
    .append("text")
    .attr("y", 6)
    .attr("dy", ".71em")
    .attr("class", "axis-label")
    .attr("transform", `translate(${2}, ${5}) rotate(-90)`)
    .style("text-anchor", "end")
    .style("dominant-baseline", "ideographic")
    .text("Weekly average price compared to yearly average price");
  // create lines
  var lineS = line()
    .curve(curveMonotoneX)
    .x((d, i) => vis.x(i + 1) + barwidth / 2)
    .y(d => vis.y(d));
  vis.path = svg
    .append("g")
    .attr("fill", "none")
    .attr("stroke-linejoin", "round")
    .attr("stroke-linecap", "round")
    .selectAll("path")
    .data(vis.data.series.values)
    .join("path")
    .style("stroke", (d, i) => vis.colorSelection[i])
    .style("stroke-width", (d, i) =>
      i === vis.data.series.values.length - 1 ? 2.5 : 1
    )
    .attr("d", d => lineS(d));
  // add the x Axis
  var xtickdelta = Math.ceil(20 / (vis.width / vis.data.dates.length));
  svg
    .append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0," + vis.height + ")")
    .call(
      axisBottom(vis.x).tickValues(
        vis.x.domain().filter(function(d, i) {
          return !((i + Math.floor(xtickdelta / 2)) % xtickdelta);
        })
      )
    );
  xtickdelta = Math.ceil(50 / (vis.width / vis.data.dates.length));
  svg
    .append("g")
    .attr("class", "axis no_x_axis")
    .attr("transform", "translate(0," + (vis.height + 25) + ")")
    .call(
      axisBottom(vis.x2).tickValues(
        vis.x2.domain().filter(function(d, i) {
          return !((i + Math.floor(xtickdelta / 2)) % xtickdelta);
        })
      )
    );
  // add a horizontal line at the max value of the yaxis
  svg
    .append("line")
    .attr("class", "xAxisLine")
    .attr("x1", vis.x(0))
    .attr("y1", 0)
    .attr("x2", vis.width)
    .attr("y2", 0);
  svg.width = vis.width;
  // tooltip y
  let yTooltipWidth = 50;
  let xTooltipWidth = 30;
  let svgName = "Seas";
  let yTooltip = createTooltips(
    this,
    null,
    null,
    xTooltipWidth,
    this.colorTheme,
    svgName,
    null,
    lightbackground2,
    lightbackground2,
    yTooltipWidth
  );
  let xTooltip = yTooltip["xTooltip"];
  yTooltip = yTooltip["yTooltip"];
  hLineCreate(svg, "Seas", grayLightBackground(this.colorTheme), 1);
  // x axis label
  svg
    .append("g")
    .append("text")
    .attr("y", 6)
    .attr("dy", ".71em")
    .attr("class", "axis-label")
    .attr(
      "transform",
      `translate(${vis.width}, ${vis.height - vis.margin.top - 3})`
    )
    .style("text-anchor", "end")
    .style("dominant-baseline", "ideographic")
    .text("ISO week number");
  // add vertical lines to show on hover
  var bandsSeas = svg
    .selectAll(".bandsSeas")
    .data([vis.data.dates])
    .enter()
    .append("g")
    .attr("class", "bandsSeas");
  bandsSeas
    .selectAll("rect")
    .data(function(d) {
      return d;
    })
    .enter()
    .append("rect")
    .attr("x", function(d) {
      return vis.x(d) + Math.floor(barwidth / 2);
    })
    .attr("y", 0)
    .attr("height", vis.height)
    .attr("width", 1)
    .attr("class", function(d, i) {
      return "bandsSeas" + i;
    })
    .style("stroke-width", Math.floor(barwidth));
  vis.hoverCandle(vis, yTooltip, xTooltip, xTooltipWidth, barwidth);
  vis.displayGen(currWeek, vis, vis.data.series.dates.length - 2);
  vis.wrangleData();
  return svg.node();
};
//hover method - on hover show lines and highlight candle
SeasonalChart.prototype.csheader = function(vis) {
  function cshrender(selection) {
    selection.each(function(d) {
      select("#" + vis.seasonalWeek).text(d.week);
      select("#seasonalWeekDate").text(d.date);
      select("#" + vis.hoverYear)
        .text(d.year)
        .style("color", vis.colorSelection[d.idx]);
      select("#" + vis.hoverVal)
        .text(vis.formatPercent(d.yearVal))
        .style("color", vis.colorSelection[d.idx]);
      select("#" + vis.seasonalAve).text(vis.formatPercent(d.value));
    });
  }
  return cshrender;
};
SeasonalChart.prototype.displayGen = function(mark, vis, s) {
  let len = vis.data.series.dates.length - 1;
  select("#" + vis.seasonalityControls)
    .datum({
      week: vis.data.series.dates[len][mark],
      date: timeFormat("%d %b")(vis.data.dts[mark]),
      value: vis.data.series.values[len][mark],
      year: vis.data.series.names[s],
      yearVal: vis.data.series.values[s][mark],
      idx: s
    })
    .call(vis.csheader(vis));
};
SeasonalChart.prototype.indexOfMin = function(arr) {
  if (arr.length === 0) {
    return -1;
  }
  var min = 100000000000000;
  var minIndex = 0;
  for (var i = 0; i < arr.length; i++) {
    if (isFinite(arr[i])) {
      if (arr[i] < min) {
        minIndex = i;
        min = arr[i];
      }
    }
  }
  return minIndex;
};
SeasonalChart.prototype.hoverF = function(vis, d) {
  const ym = vis.y.invert(event.layerY - vis.margin.top);
  let arr = [];
  vis.data.series.values.forEach((dat, idx) =>
    arr.push(Math.abs(vis.data.series.values[idx][d] - ym))
  );
  const s = vis.indexOfMin(arr);
  vis.path
    .style("stroke-width", (dat, idx) =>
      idx === s || idx === vis.data.series.values.length - 1 ? 2.5 : 0.5
    )
    .filter((dat, idx) => idx === s)
    .raise();
  return s;
};
//hover method - on hover show lines and highlight candle
SeasonalChart.prototype.hoverCandle = function(
  vis,
  yTooltip,
  xTooltip,
  xTooltipWidth,
  barWidth
) {
  select("#" + vis.childElement)
    .select(".bandsSeas")
    .selectAll("rect")
    .on("mouseover", function(d, i) {
      event.preventDefault();
      select(this).classed("hoved", true);
      let s = vis.hoverF(vis, i);
      vis.displayGen(i, vis, s);
    })
    .on("mousemove", function(d, i) {
      const xt = vis.x;
      event.preventDefault();
      select(this).classed("hoved", true);
      const s = vis.hoverF(vis, i);
      vis.displayGen(i, vis, s);
      const yt = vis.y;
      const yPixels = Math.max(
        Math.min(event.layerY - vis.margin.top, vis.height),
        0
      );
      const xRate = xt(d);
      const yRate = yt.invert(yPixels);
      yTooltip
        .style("opacity", 1)
        .style("left", "0px")
        .style("top", yPixels + vis.margin.top - 9 + "px")
        .html(format(vis.formatPercent)(yRate));

      xTooltip
        .style("opacity", 1)
        .style(
          "left",
          xRate +
            vis.margin.left +
            Math.round((barWidth - xTooltipWidth) / 2) +
            "px"
        )
        .style("top", vis.height + vis.margin.top + 2 + "px")
        .html(d);

      select(".hHoverLineSeas")
        .style("opacity", 1)
        .attr("y1", yPixels)
        .attr("y2", yPixels);
    })
    .on("mouseout", function() {
      select(this).classed("hoved", false);
      vis.path.style("stroke-width", (d, i) =>
        i === vis.data.series.values.length - 1 ? 2.5 : 1
      );
      vis.displayGen(
        vis.data.series.dates[vis.data.series.dates.length - 2].length - 1,
        vis,
        vis.data.series.dates.length - 2
      );
      yTooltip
        .style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");

      xTooltip
        .style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");
      select(".hHoverLineSeas").style("opacity", 0);
    });
};
//wrangleData method - selecting/filtering the data we want to use
SeasonalChart.prototype.wrangleData = function() {
  var vis = this;
  vis.updateVis();
};
//updateVis method - updating our elements to match the new data
SeasonalChart.prototype.updateVis = function() {};
